
/**
 * Gender value in enum
 *
 * @export
 * @enum {number}
 */
export enum GenderEnum {

  /**
   * Default value when gender is null, undefined, or empty.
   */
  NoneProvided = 0,
  Male,
  Female,

  /**
   * Option for people who do not want say
   */
  NotSpecified = 9
}

export type Gender = GenderEnum.NoneProvided | GenderEnum.Male | GenderEnum.Female | GenderEnum.NotSpecified;
